(function () {
  var KEY = 'metamall_wishlist_handles';
  var LEGACY_KEY = 'user_wishlist';
  var memoryList = [];

  function hasStorage() {
    try {
      window.localStorage.setItem('__metamall_wishlist_test__', '1');
      window.localStorage.removeItem('__metamall_wishlist_test__');
      return true;
    } catch (error) {
      return false;
    }
  }

  var storageReady = hasStorage();

  function normalize(handle) {
    return String(handle || '').trim().toLowerCase();
  }

  function unique(list) {
    var map = {};
    var output = [];
    (Array.isArray(list) ? list : []).forEach(function (item) {
      var handle = normalize(item);
      if (!handle || map[handle]) return;
      map[handle] = true;
      output.push(handle);
    });
    return output;
  }

  function parse(raw) {
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.handles)) return parsed.handles;
    } catch (error) {
      return [];
    }
    return [];
  }

  function getList() {
    if (!storageReady) return unique(memoryList);

    var list = parse(window.localStorage.getItem(KEY));
    if (!list.length) {
      list = parse(window.localStorage.getItem(LEGACY_KEY));
      if (list.length) saveList(list, true);
    }
    return unique(list);
  }

  function saveList(list, silent) {
    var normalized = unique(list);
    if (storageReady) {
      if (normalized.length) {
        window.localStorage.setItem(KEY, JSON.stringify(normalized));
      } else {
        window.localStorage.removeItem(KEY);
      }
      window.localStorage.setItem(LEGACY_KEY, JSON.stringify(normalized));
    } else {
      memoryList = normalized.slice();
    }
    updateAll(normalized);
    if (!silent) {
      document.dispatchEvent(new CustomEvent('metamall:wishlist:updated', { detail: { handles: normalized } }));
    }
    return normalized;
  }

  function contains(handle) {
    return getList().indexOf(normalize(handle)) !== -1;
  }

  function add(handle) {
    var list = getList();
    var normalized = normalize(handle);
    if (!normalized || list.indexOf(normalized) !== -1) return list;
    list.push(normalized);
    return saveList(list);
  }

  function remove(handle) {
    var normalized = normalize(handle);
    return saveList(getList().filter(function (item) { return item !== normalized; }));
  }

  function toggle(handle) {
    if (contains(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  function updateCounters(list) {
    var count = (list || getList()).length;
    document.querySelectorAll('[data-metamall-wishlist-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count === 0 && node.hasAttribute('data-hide-when-empty');
    });
  }

  function wishlistIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
      '<path d="M20.8 4.7c-2.1-2.1-5.5-2-7.6.2L12 6.1l-1.2-1.2C8.7 2.7 5.3 2.6 3.2 4.7 1 6.9 1 10.5 3.3 12.8l7.9 7.8c.4.4 1.1.4 1.5 0l7.9-7.8c2.4-2.3 2.4-5.9.2-8.1Z"/>',
      '</svg>'
    ].join('');
  }

  function previewThemeId() {
    var params = new URLSearchParams(window.location.search || '');
    var fromUrl = params.get('preview_theme_id');
    if (fromUrl) {
      try {
        window.sessionStorage.setItem('metamall_preview_theme_id', fromUrl);
      } catch (error) {}
      return fromUrl;
    }

    var shopifyTheme = window.Shopify && window.Shopify.theme;
    if (shopifyTheme && shopifyTheme.id && shopifyTheme.role && shopifyTheme.role !== 'main') {
      var fromShopifyTheme = String(shopifyTheme.id);
      try {
        window.sessionStorage.setItem('metamall_preview_theme_id', fromShopifyTheme);
      } catch (error) {}
      return fromShopifyTheme;
    }

    try {
      return window.sessionStorage.getItem('metamall_preview_theme_id') || '';
    } catch (error) {
      return '';
    }
  }

  function wishlistPageUrl() {
    var previewId = previewThemeId();
    return previewId ? '/pages/wishlist?preview_theme_id=' + encodeURIComponent(previewId) : '/pages/wishlist';
  }

  function decodeHandle(value) {
    try {
      return decodeURIComponent(String(value || '').split('?')[0].split('#')[0]);
    } catch (error) {
      return String(value || '').split('?')[0].split('#')[0];
    }
  }

  function handleFromUrl(href) {
    if (!href) return '';
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? normalize(decodeHandle(match[1])) : '';
    } catch (error) {
      var fallback = String(href).match(/\/products\/([^/?#]+)/);
      return fallback ? normalize(decodeHandle(fallback[1])) : '';
    }
  }

  function wishlistButtonHtml(handle, label, extraClass) {
    return [
      '<button type="button" class="metamall-wishlist-button ' + (extraClass || '') + '"',
      ' data-metamall-wishlist-button data-product-handle="' + escapeHtml(handle) + '"',
      ' aria-label="' + escapeHtml(label || 'お気に入りに追加') + '" aria-pressed="false">',
      wishlistIcon(),
      '</button>'
    ].join('');
  }

  function injectHeaderButton() {
    if (document.querySelector('.metamall-wishlist-header-link')) return;

    var header = document.querySelector('header, .shopify-section-header, [data-section-type*="header"], .header');
    if (!header) return;

    var cartNode = header.querySelector('a[href$="/cart"], a[href*="/cart"], button[aria-label*="カート"], [data-cart-drawer-trigger]');
    var link = document.createElement('a');
    link.className = 'metamall-wishlist-header-link';
    link.href = wishlistPageUrl();
    link.setAttribute('aria-label', 'お気に入り');
    link.innerHTML = wishlistIcon() + '<span class="metamall-wishlist-header-link__count" data-metamall-wishlist-count data-hide-when-empty hidden>0</span>';

    if (cartNode && cartNode.parentNode) {
      cartNode.parentNode.insertBefore(link, cartNode);
      return;
    }

    var iconArea = header.querySelector('.header__icons, .header-icons, .header__icon-list, .mobile-header__icons');
    if (iconArea) {
      iconArea.appendChild(link);
      return;
    }

    header.appendChild(link);
  }

  function syncHeaderWishlistLinks() {
    var url = wishlistPageUrl();
    document.querySelectorAll('.metamall-wishlist-header-link').forEach(function (link) {
      link.setAttribute('href', url);
    });
  }

  function shouldSkipProductCard(card) {
    if (!card) return true;
    if (card.classList.contains('product-card--list')) return true;
    if (card.closest('.pr-img-card, .card-media, .image-column, .card-media--link, .metamall-wishlist-page')) return true;
    return false;
  }

  function imageTargetFromLink(link) {
    if (!link) return null;
    var card = link.closest('.product-card');
    if (shouldSkipProductCard(card)) return null;
    return card.querySelector('.product-card__image-wrapper');
  }

  function injectCardButtons() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (link) {
      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) return;

      var target = imageTargetFromLink(link);
      if (!target || target.querySelector('[data-metamall-wishlist-button]')) return;
      if (!target.querySelector('img')) return;

      target.classList.add('metamall-wishlist-card-target');
      target.insertAdjacentHTML('beforeend', wishlistButtonHtml(handle, 'お気に入りに追加', 'metamall-wishlist-button--card product-list-collect-btn btn btn--icon-circle'));
    });
  }
  function productDetailMediaTarget() {
    var selectors = [
      '.product__media-gallery-viewer .swiper-slide-active .product__media-item-container',
      '.product__media-gallery-viewer .product__media-item[data-media-index="0"] .product__media-item-container',
      '.product__media-gallery-viewer .product__media-item .product__media-item-container',
      '.product__media-gallery-viewer-wrap',
      '.product__media-gallery-viewer',
      '.product__media-gallery',
      '.product__media-wrapper'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var target = document.querySelector(selectors[i]);
      if (target) return target;
    }

    return null;
  }

  function injectProductDetailButton() {
    var match = window.location.pathname.match(/\/products\/([^/]+)/);
    var handle = match ? normalize(decodeHandle(match[1])) : '';
    if (!handle) return;

    var targets = document.querySelectorAll('.product__info-container .product__block--meta, .product__info-wrapper .product__block--meta, product-info .product__block--meta');
    var target = null;

    for (var i = 0; i < targets.length; i += 1) {
      if (targets[i].closest('.product__info-wrapper.v-scrollable')) continue;
      if (targets[i].offsetWidth || targets[i].offsetHeight || targets[i].getClientRects().length) {
        target = targets[i];
        break;
      }
    }

    if (!target) return;

    target.classList.add('metamall-wishlist-detail-meta-target');

    var wrapper = target.querySelector('.metamall-wishlist-detail-entry') || document.createElement('div');
    wrapper.className = 'metamall-wishlist-detail-entry';

    var button = wrapper.querySelector('[data-metamall-wishlist-button]');
    if (!button || normalize(button.getAttribute('data-product-handle')) !== handle) {
      wrapper.innerHTML = wishlistButtonHtml(handle, 'お気に入りに追加', 'metamall-wishlist-button--detail');
    }

    if (!wrapper.parentNode) {
      target.appendChild(wrapper);
    }
  }
  function bindProductDetailMediaSync() {
    var galleries = document.querySelectorAll('product-info[id^="MainProduct"] media-gallery, media-gallery.product__media-gallery');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.metamallWishlistMediaSync === 'true') return;

      gallery.dataset.metamallWishlistMediaSync = 'true';
      gallery.addEventListener('media-gallery:media-change', function () {
        window.setTimeout(function () {
          injectProductDetailButton();
          updateButtons(getList());
        }, 0);
      });
    });
  }

  function injectGlobalButtons() {
    injectHeaderButton();
    syncHeaderWishlistLinks();
    injectCardButtons();
    injectProductDetailButton();
    bindProductDetailMediaSync();
  }

  function updateButtons(list) {
    var map = {};
    (list || getList()).forEach(function (handle) { map[handle] = true; });
    document.querySelectorAll('[data-metamall-wishlist-button]').forEach(function (button) {
      var handle = normalize(button.getAttribute('data-product-handle'));
      var active = !!map[handle];
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? 'お気に入りから削除' : 'お気に入りに追加';
      button.setAttribute('aria-label', label);
      var text = button.querySelector('[data-metamall-wishlist-label]');
      if (!text && button.closest('.metamall-wishlist-detail-entry')) {
        text = button.closest('.metamall-wishlist-detail-entry').querySelector('[data-metamall-wishlist-label]');
      }
      if (text) text.textContent = active ? 'お気に入りに追加済み' : 'お気に入りに追加';
    });
  }

  function updateAll(list) {
    injectGlobalButtons();
    updateCounters(list);
    updateButtons(list);
  }

  function formatMoney(cents) {
    var value = typeof cents === 'number' ? cents : 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, window.Shopify.money_format || '{{amount}}');
    }
    return '¥' + Math.round(value / 100).toLocaleString('ja-JP');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getVariant(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].available) return variants[i];
    }
    return variants[0] || null;
  }

  function taxLabelHtml() {
    return '<span class="metamall-tax-label">(税込み)</span>';
  }

  function priceWithTax(cents) {
    return formatMoney(cents) + taxLabelHtml();
  }

  function priceHtml(product, variant) {
    var price = typeof product.price === 'number' ? product.price : ((variant && variant.price) || 0);
    var compareAtPrice = typeof product.compare_at_price === 'number' ? product.compare_at_price : ((variant && variant.compare_at_price) || 0);
    var onSale = compareAtPrice > price;
    var priceClass = 'f-price' + (onSale ? ' f-price--on-sale' : '') + (!variant || !variant.available ? ' f-price--sold-out' : '');
    return [
      '<div class="' + priceClass + '">',
      '<div class="f-price__regular">',
      '<span class="visually-hidden visually-hidden--inline">通常価格</span>',
      '<span class="f-price-item f-price-item--regular">' + (onSale ? '' : priceWithTax(price)) + '</span>',
      '</div>',
      '<div class="f-price__sale">',
      '<span class="visually-hidden visually-hidden--inline">セール価格</span>',
      '<span class="f-price-item f-price-item--sale">' + (onSale ? priceWithTax(price) : '') + '</span>',
      onSale ? '<span class="visually-hidden visually-hidden--inline">通常価格</span><span class="f-price-item f-price-item--regular"><s>' + priceWithTax(compareAtPrice) + '</s></span>' : '',
      '</div>',
      '</div>'
    ].join('');
  }

  function cartIconHtml() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.3 6h15.1l-1.8 9.2H8.1L6.3 6Z"></path><path d="M6.3 6 5.8 3.8H3"></path><path d="M9 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M18 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path></svg>';
  }

  function cardHtml(product) {
    var variant = getVariant(product);
    var image = product.featured_image || '//cdn.shopify.com/s/images/admin/no-image-compact.gif';
    var disabled = !variant || !variant.available;
    var productUrl = '/products/' + encodeURIComponent(product.handle);
    var cardClass = 'metamall-wishlist-page__card product-card product-card-style-standard color-inherit' + (disabled ? ' is-unavailable' : '');
    var buttonText = disabled ? '売り切れ' : 'カートに追加';
    return [
      '<article class="' + cardClass + '" data-product-handle="' + escapeHtml(product.handle) + '">',
      '<div class="product-card__wrapper h-full">',
      '<div class="product-card__image-wrapper product-card__image-wrapper--main-only bg-none">',
      '<a href="' + productUrl + '" aria-label="' + escapeHtml(product.title) + '" tabindex="-1">',
      '<motion-element data-motion="zoom-out-sm" class="block">',
      '<div class="media-wrapper product-card__image product-card__image--main metamall-wishlist-page__image" style="--aspect-ratio: 1; --aspect-ratio-mobile: 1;">',
      '<img class="motion-reduce" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" decoding="async">',
      '</div>',
      '</motion-element>',
      '</a>',
      '<button type="button" class="metamall-wishlist-page__remove" data-metamall-wishlist-remove="' + escapeHtml(product.handle) + '" aria-label="削除">×</button>',
      '<div class="product-card__actions product-card__main-actions metamall-wishlist-page__product-actions">',
      '<button type="button" class="product-card__atc product-card__action-button btn btn--primary" data-metamall-wishlist-add-cart="' + (variant ? variant.id : '') + '"' + (disabled ? ' disabled' : '') + '>',
      '<span class="btn__text flex gap-1 items-center">',
      '<span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">' + cartIconHtml() + '</span>',
      '<span class="product-card__atc-text product-card__action-text">' + buttonText + '</span>',
      '</span>',
      '</button>',
      '</div>',
      '</div>',
      '<div class="product-card__info text-left">',
      '<h3 class="product-card__title text-pcard-title">',
      '<a class="reversed-link block text-limit-2-lines" href="' + productUrl + '"><span class="reversed-link__text">' + escapeHtml(product.title) + '</span></a>',
      '</h3>',
      priceHtml(product, variant),
      '</div>',
      '</div>',
      '</article>'
    ].join('');
  }

  function setWishlistPageState(state) {
    document.querySelectorAll('[data-metamall-wishlist-page]').forEach(function (root) {
      root.setAttribute('data-metamall-wishlist-page-state', state);
    });

    document.querySelectorAll('[data-metamall-wishlist-state]').forEach(function (node) {
      node.hidden = node.getAttribute('data-metamall-wishlist-state') !== state;
    });
  }

  function ensureWishlistPageRoot() {
    if (document.querySelector('[data-metamall-wishlist-page]')) return;
    if (!/\/pages\/wishlist\/?$/.test(window.location.pathname)) return;

    var main = document.querySelector('main#MainContent, #MainContent, main') || document.body;
    var section = document.createElement('section');
    section.className = 'metamall-wishlist-page color-scheme-1';
    section.setAttribute('data-metamall-wishlist-page', '');
    section.innerHTML = [
      '<div class="metamall-wishlist-page__inner">',
      '<div class="metamall-wishlist-page__header">',
      '<div><h1 class="metamall-wishlist-page__title">お気に入り</h1>',
      '<div class="metamall-wishlist-page__meta"><span data-metamall-wishlist-count>0</span> 件の商品</div></div>',
      '<a class="metamall-wishlist-page__btn metamall-wishlist-page__btn--secondary" href="/">閲覧を続けます</a>',
      '</div>',
      '<div class="metamall-wishlist-page__empty" data-metamall-wishlist-state="empty" hidden>',
      '<div><div class="metamall-wishlist-page__logo">',
      '<svg class="metamall-wishlist-page__logo-svg" viewBox="0 0 64 52" aria-hidden="true" focusable="false">',
      '<path class="metamall-wishlist-page__logo-face" d="M6 46V6h12l14 21L46 6h12v40H45V27L32 46 19 27v19H6Z"></path>',
      '<path class="metamall-wishlist-page__logo-shade" d="M18 6h8l6 9-7 10L18 14V6Zm28 0h12v40H45V27L32 46l-7-10L46 6Z"></path>',
      '<path class="metamall-wishlist-page__logo-edge" d="M6 46h13V27l13 19 13-19v19h13"></path>',
      '</svg><span class="metamall-wishlist-page__logo-divider"></span><span class="metamall-wishlist-page__logo-word">META</span></div>',
      '<h2 class="metamall-wishlist-page__empty-title">お気に入り商品が<span>登録されておりません。</span></h2>',
      '<div class="metamall-wishlist-page__actions"><a class="metamall-wishlist-page__btn metamall-wishlist-page__btn--primary" href="/">閲覧を続けます</a></div>',
      '</div></div>',
      '<div class="metamall-wishlist-page__empty" data-metamall-wishlist-state="loading"><div>お気に入り商品を読み込み中です...</div></div>',
      '<div class="metamall-wishlist-page__grid" data-metamall-wishlist-grid data-metamall-wishlist-state="grid" hidden></div>',
      '</div>'
    ].join('');
    main.prepend(section);
  }
  function loadWishlistPage() {
    ensureWishlistPageRoot();

    var root = document.querySelector('[data-metamall-wishlist-page]');
    if (!root) return;

    var grid = root.querySelector('[data-metamall-wishlist-grid]');
    var handles = getList();

    if (!handles.length) {
      if (grid) grid.innerHTML = '';
      setWishlistPageState('empty');
      return;
    }

    setWishlistPageState('loading');
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .catch(function () { return null; });
    })).then(function (products) {
      var validProducts = products.filter(Boolean);
      saveList(validProducts.map(function (product) { return product.handle; }), true);
      if (!validProducts.length) {
        if (grid) grid.innerHTML = '';
        setWishlistPageState('empty');
        return;
      }
      if (grid) grid.innerHTML = validProducts.map(cardHtml).join('');
      setWishlistPageState('grid');
    });
  }

  function addVariantToCart(variantId, checkout) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      if (checkout) {
        window.location.href = '/checkout';
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-metamall-wishlist-button]');
    if (button) {
      event.preventDefault();
      toggle(button.getAttribute('data-product-handle'));
      loadWishlistPage();
      return;
    }

    var removeButton = event.target.closest('[data-metamall-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      remove(removeButton.getAttribute('data-metamall-wishlist-remove'));
      loadWishlistPage();
      return;
    }

    var cartButton = event.target.closest('[data-metamall-wishlist-add-cart]');
    if (cartButton && !cartButton.disabled) {
      event.preventDefault();
      addVariantToCart(cartButton.getAttribute('data-metamall-wishlist-add-cart'), false);
      return;
    }

    var buyNowButton = event.target.closest('[data-metamall-wishlist-buy-now]');
    if (buyNowButton && !buyNowButton.disabled) {
      event.preventDefault();
      addVariantToCart(buyNowButton.getAttribute('data-metamall-wishlist-buy-now'), true);
    }
  });

  window.MetaMallWishlist = {
    getList: getList,
    add: add,
    remove: remove,
    toggle: toggle,
    contains: contains,
    refresh: function () {
      injectGlobalButtons();
      updateAll(getList());
      loadWishlistPage();
    }
  };

  document.addEventListener('DOMContentLoaded', window.MetaMallWishlist.refresh);
  document.addEventListener('shopify:section:load', window.MetaMallWishlist.refresh);
  document.addEventListener('shopify:section:select', window.MetaMallWishlist.refresh);
  window.setTimeout(window.MetaMallWishlist.refresh, 800);
  window.addEventListener('storage', function (event) {
    if (event.key === KEY || event.key === LEGACY_KEY) window.MetaMallWishlist.refresh();
  });
})();
